<template>
    <div v-if="loaded" class="container white-page-container d-flex align-items-center justify-content-center">
        <div v-if="success && unsubscribe && code === 'UNSUBSCRIBED'">
            <div class="text-center mt-6">
                <img class="ot-logo" :src="otLogo" alt="logo de l'office de tourisme">
            </div>

            <h4 class="text-center mt-6 information-text">Votre demande a bien été prise en compte.</h4>
        </div>

        <div v-if="success">
            <div class="text-center mt-6">
                <img class="ot-logo" :src="otLogo" alt="logo de l'office de tourisme">
            </div>

            <div v-html="message" class="text-center mt-6 text-black font-weight-bold"></div>
        </div>

        <div v-else-if="!success && code === 'ALREADY_ANSWERED'">
            <div class="text-center mt-6">
                <img class="ot-logo" :src="otLogo" alt="logo de l'office de tourisme">
            </div>
            <h4 class="text-center mt-6 information-text">Vous avez déjà répondu à cette sollicitation</h4>
        </div>

        <div v-else-if="!success && code === 'NOT_FOUND'">
            <h4 class="text-center mt-6 information-text">Cette sollicitation n'existe plus</h4>
        </div>
    </div>
</template>

<script>
export default {
    name: "WhitePage",
    data() {
        return {
            vtcDiffId: null,
            approval: true,
            otLogo: null,
            success: true,
            code: null,
            loaded: false,
            message: null,
            unsubscribe: false,
        }
    },
    methods: {
        getLogo() {
            this.$http.get("veille-tourisme/account-logo/" + this.vtcDiffId).then((res) => {
                this.otLogo = res.body.data.logo
            })
        },
        acceptDiffs() {
            this.$http.put("veille-tourisme/accept", { "id": this.vtcDiffId }).then((res) => {
                this.success = res.body.success
                this.code = res.body.code

                if (this.success) {
                    this.message = res.body.data.message
                }

                this.loaded = true
            })
        },
        refuseDiffs() {
            this.$http.put("veille-tourisme/refuse", { "id": this.vtcDiffId }).then((res) => {
                this.success = res.body.success
                this.code = res.body.code

                if (this.success) {
                    this.message = res.body.data.message
                }

                this.loaded = true
            })
        },
        unsubscribeProvider() {
            this.$http.put("veille-tourisme/unsubscribed", { "id": this.vtcDiffId }).then((res) => {
                this.success = res.body.success
                this.code = res.body.code

                this.loaded = true
            })
        },
    },
    created() {
        window.Intercom("shutdown")
        window.Intercom("hide")

        this.vtcDiffId = atob(this.$route.params.vtcDiffId)

        if (this.$route.fullPath.includes("denial")) {
            this.approval = false
        }

        if (this.$route.fullPath.includes("unsubscribed")) {
            this.unsubscribe = true
        }

        if (this.approval && !this.unsubscribe) {
            this.acceptDiffs()
        } else if(!this.approval && !this.unsubscribe) {
            this.refuseDiffs()
        } else {
            this.unsubscribeProvider()
        }

        if(this.code !== 'NOT_FOUND') {
            this.getLogo()
        }
    },
}
</script>